var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#1329FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 23C24 22.0807 23.8189 21.1705 23.4672 20.3212C23.1154 19.4719 22.5998 18.7003 21.9497 18.0503C21.2997 17.4002 20.5281 16.8846 19.6788 16.5328C18.8295 16.1811 17.9193 16 17 16L17 23H24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15C24 14.0807 23.8189 13.1705 23.4672 12.3212C23.1154 11.4719 22.5998 10.7003 21.9497 10.0503C21.2997 9.40024 20.5281 8.88463 19.6788 8.53284C18.8295 8.18106 17.9193 8 17 8L17 15H24Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16H16V23H9V16Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H16V15H9V8Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo.f3a96214.svg";
export { ForwardRef as ReactComponent };